export type InsuranceType = "火災保険" | "地震保険";

export const getInsuranceTypeKeys = (insuranceType: InsuranceType): string[] => {
  switch (insuranceType) {
    case "火災保険":
      return ["fire_insurance_cost", "fire_insurance_holding_period"];
    case "地震保険":
      return ["earthquake_insurance_cost", "earthquake_insurance_holding_period"];
    default:
      return [];
  }
};
